import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "ai",
    iconColor: "white",
    text: "AI enabled smart data \nprocessing for 'Marketing \nObservability'",
    listItemCustomStyle: { width: "290px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "cloudWithCircleAndPowerIcon",
    iconColor: "white",
    text: "Near real-time AI-based \nnudges & foresights",
    listItemCustomStyle: { width: "290px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "gearInsidePersonTalking",
    iconColor: "white",
    text: "Gen AI based \n'Marketing Decision \nAssistant'",
    listItemCustomStyle: { width: "290px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_AI_TWIN_1 = {
  title: "MEASURE, MONITOR AND PIVOT THE \nMARKETING STRATEGY IN REAL TIME",
  titleNumber: "1.",
  text: "AI-Twin will observe marketing signals across consumer behavior, campaign performance,\n channel effectiveness, competitor, and industry analysis. AI-Twin will correlate these signals \nto derive marketing KPIs to nudge the marketer with foresights, and tactics.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("AITWIN_303"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("AITWIN_301"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "AI_TWIN/AI_Twin_02.png",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "AI_TWIN/InfosysTopazLogo.png",
};
